import { type FC } from 'react';
import type { TaskV1AssignmentReason } from '@/model/Task.model';
import { _notNil } from '@/littledash';
import { formatAggregateAssignmentReason } from '@/model/Task.utils';

/**
 * Renders a chip displaying the human-readable assignment reason for a task,
 * indicating why animals were assigned (by age, study day, schedule type, etc.).
 */
export const TaskAssignmentReasonChip: FC<{ assignmentReason: TaskV1AssignmentReason }> = ({ assignmentReason }) => {
  if (!_notNil(assignmentReason)) {
    return null;
  }

  const label = formatAggregateAssignmentReason(assignmentReason);

  if (label === null) {
    return null;
  }

  return (
    <span
      className="ml2 bg-near-white b--moon-gray pa1 f7 ba br2 near-black"
      data-test-component="TaskAssignmentReasonChip"
      data-test-element="container"
      data-testid="task-assignment-reason-chip"
    >
      {label}
    </span>
  );
};
